<template>
  <el-table-column
    prop="stowage.receipt_number"
    sortable="custom"
    label="Kapcsolódó rakodási lista"
    show-overflow-tooltip
    min-width="220"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.stowage_receipt_number"
        style="display: inline-block;"
      >
        <remote-link
          :label="scope.row.stowage_receipt_number"
          :path="scope.row.stowage_receipt_file_url"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó rakodási lista</el-tag>
    </template>
  </el-table-column>
</template>

<script>
import RemoteLink from '../../../utils/RemoteLink';

export default {
  components: { RemoteLink },
  propName: 'stowage.receipt_number',
};
</script>

